/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerName
 */
export interface PartnerName {
    /**
     * 
     * @type {string}
     * @memberof PartnerName
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerName
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerName
     */
    middleName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerName
     */
    gender?: string;
}

/**
 * Check if a given object implements the PartnerName interface.
 */
export function instanceOfPartnerName(value: object): value is PartnerName {
    return true;
}

export function PartnerNameFromJSON(json: any): PartnerName {
    return PartnerNameFromJSONTyped(json, false);
}

export function PartnerNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerName {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'gender': json['gender'] == null ? undefined : json['gender'],
    };
}

export function PartnerNameToJSON(json: any): PartnerName {
    return PartnerNameToJSONTyped(json, false);
}

export function PartnerNameToJSONTyped(value?: PartnerName | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'middleName': value['middleName'],
        'gender': value['gender'],
    };
}

